import { render, staticRenderFns } from "./AddressViewAllModal.vue?vue&type=template&id=48d1ad6c"
import script from "./AddressViewAllModal.vue?vue&type=script&lang=js"
export * from "./AddressViewAllModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports